import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tz']

  connect () {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (timezone) {
      this.tzTarget.value = timezone
    }
  }
}
